var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11197 0.571613C0.916775 0.376286 0.600192 0.376181 0.404865 0.571378C0.209538 0.766575 0.209432 1.08316 0.40463 1.27848L1.11197 0.571613ZM3.05677 3.22505L2.7031 3.57848L3.05677 3.93239L3.41044 3.57848L3.05677 3.22505ZM5.70891 1.27848C5.9041 1.08316 5.904 0.766575 5.70867 0.571378C5.51334 0.376181 5.19676 0.376286 5.00156 0.571613L5.70891 1.27848ZM0.40463 1.27848L2.7031 3.57848L3.41044 2.87161L1.11197 0.571613L0.40463 1.27848ZM3.41044 3.57848L5.70891 1.27848L5.00156 0.571613L2.7031 2.87161L3.41044 3.57848Z",
    fill: "#867586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a3d12b127bf4c125632decb54f8a13f2.svg";
export { ForwardRef as ReactComponent };